const navButtons = [
   { id: 0, name: "co robimy?", scrollTo: "header", link: "" },
   { id: 2, name: "współpraca", scrollTo: "wspolpraca", link: "/wspolpraca" },
   { id: 3, name: "o nas", scrollTo: "aboutUs", link: "" },
   { id: 4, name: "nasze projekty", scrollTo: "timeline", link: "" },
   { id: 1, name: "kontakt", scrollTo: "contact", link: "" },
 ];
 
 export default navButtons;
 